import * as React from "react";
import { cn } from "../../utils/cn";

export interface ImgProps extends React.HTMLProps<HTMLImageElement> {}

const Img = React.forwardRef<HTMLImageElement, ImgProps>(({ className, ...props }, ref) => {
  return <img className={cn("", className)} ref={ref} {...props} />;
});

Img.displayName = "Img";

export { Img };
